import React from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import Axios from 'axios';
import './scss/main.scss';
import './App.css';
import { MuiThemeProvider } from '@material-ui/core/styles';

import auth from './libs/auth';
import { DialogProvider } from './context/Dialog';
import { StudentPerspectiveProvider } from './context/StudentPerspective';
import defaultTheme from './themes/defaultTheme';
import { ServerError } from './components/Errors';

import Home from './views/home';
import PrivacyPolicy from './views/privacy-policy';

import AdminLogin from './views/admin/login';
import AdminCourses from './views/admin/courses';
import AdminCourseAssignments from './views/admin/courses/course_id/assignments';
import AdminCourseAssignmentStudent from './views/admin/courses/course_id/assignments/assignment_id/students/student_id';
import AdminInvestigate from './views/admin/investigate';
import AdminAssignmentSpecs from './views/admin/specs/assignmentspecs';
import AdminSpecView from './views/admin/specs/specview';
import AdminCourseAssignmentSpecs from './views/admin/courses/course_id/assignments/assignment_id/specs';
import AdminReports from './views/admin/reports';
import AdminSpecs from './views/admin/specs';
import AdminSpecComments from './views/admin/spec-comments';
import AdminsSpecsCreate from './views/admin/specs/create';
import AdminAnnouncements from './views/admin/announcements';
import AdminFiles from './views/admin/files';
import AdminFilesBrowser from './views/admin/files/browser';
import AdminStudents from './views/admin/students';
import AdminStudentCourses from './views/admin/students/student_id/courses';
import AdminStudentCourseWorks from './views/admin/students/student_id/courses/course_id/assignments';

import StudentCourses from './views/student/courses';
import StudentCourseAssignments from './views/student/courses/course_id/assignments';
import StudentCourseAssignment from './views/student/courses/course_id/assignments/assignment_id';
import StudentLogin from './views/student/login';
import DocumentParser from './views/admin/document-parser';
import PageNotFound from './views/errors/page-not-found';

Axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:7777' : '';
Axios.interceptors.request.use(async (config) => {
  const session = auth.getSession();
  if (session) config.headers = { Authorization: session.accessToken};
  return config;
});


Axios.interceptors.response.use(response => response, error => {
  const session = auth.getSession();
  if (error.response) {
    const status = error.response.status;
    const loginLoc = session?.user?.admin ? 'admin' : 'student';
    if (status === 401) {
      auth.logout();
      window.location.href = `/#/${loginLoc}/login`;
    }
  }
  return Promise.reject(error); 
});

const App = () => {
  return (
    <MuiThemeProvider theme={defaultTheme}>
      <DialogProvider>
        <StudentPerspectiveProvider>
          <Router>
            {/* <ServerError axios={Axios} />  commented out for moodle implementation*/}
            <div className="App">
              <Switch>
                <Route
                  path="/admin/document-parser"
                  component={DocumentParser}
                  exact
                />
                <Route
                  path="/admin/courses/:course_id/assignments/:assignment_id/students/:student_id"
                  component={AdminCourseAssignmentStudent}
                  exact
                />
                <Route
                  path="/admin/courses/:course_id/assignments"
                  component={AdminCourseAssignments}
                  exact
                />
                <Route path="/admin/courses" component={AdminCourses} exact />
                <Route
                  path="/admin/courses/:course_id/specs/:assignment_id"
                  component={AdminAssignmentSpecs}
                  exact
                />
                <Route
                  path="/admin/courses/:course_id/assignments/:assignment_id/specs"
                  component={AdminCourseAssignmentSpecs}
                  exact
                />
                <Route path="/admin/specs" component={AdminSpecs} exact />
                <Route path="/admin/spec-comments" component={AdminSpecComments} exact />
                <Route
                  path="/admin/specs/create"
                  component={AdminsSpecsCreate}
                  exact
                />
                <Route
                  path="/admin/specs/:spec_name"
                  component={AdminSpecView}
                  exact
                />
                <Route
                  path="/admin/reports/:course_id/:course_name"
                  component={AdminReports}
                  exact
                />
                <Route path="/admin/login" component={AdminLogin} exact />
                <Route
                  path="/admin/investigate"
                  component={AdminInvestigate}
                  exact
                />
                <Route
                  path="/admin/announcements"
                  component={AdminAnnouncements}
                  exact
                />
                <Route
                  path="/admin/students"
                  component={AdminStudents}
                  exact
                />
                <Route
                  path="/admin/students/:student_id/courses"
                  component={AdminStudentCourses}
                  exact
                />
                <Route
                  path="/admin/students/:student_id/courses/:course_id/assignments"
                  component={AdminStudentCourseWorks}
                  exact
                />
                <Route path="/admin" exact>
                  <Redirect
                    to={`/admin/${
                      auth.isAdmin()
                        ? 'courses'
                        : 'login'
                    }`}
                  />
                </Route>
                <Route path="/admin/files/:file_id" component={AdminFiles} exact />
                <Route
                  path="/admin/files/browser/:file_id"
                  component={AdminFilesBrowser}
                  exact
                />
                <Route
                  path="/student/courses/:course_id/assignments/:assignment_id"
                  component={StudentCourseAssignment}
                  exact
                />
                <Route
                  path="/student/courses/:course_id/assignments"
                  component={StudentCourseAssignments}
                  exact
                />
                <Route path="/student/courses" component={StudentCourses} exact />
                <Route path="/student/login" component={StudentLogin} exact />
                <Route path="/student" exact>
                  <Redirect
                    to={`/student/${
                      auth.isStudent()
                        ? 'courses'
                        : 'login'
                    }`}
                  />
                </Route>

                <Route path="/" component={Home} exact />
                <Route path="/privacy-policy" component={PrivacyPolicy} exact />
                <Route path="*" component={PageNotFound} exact />
                {/* <Route path="/login/redirect" component={() => {alert();}} /> */}
              </Switch>
            </div>
          </Router>
        </StudentPerspectiveProvider>
      </DialogProvider>
    </MuiThemeProvider>
  );
};

export default App;
